import React from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import {removeForIndicators} from "../../actions/indicators";
import LocaleUtils from "qwc2/utils/LocaleUtils";
import TypeUtils from "../../utils/TypeUtils";
import geojsonBbox from "geojson-bounding-box";
import {panTo, zoomToExtent} from "qwc2/actions/map";
import Icon from "qwc2/components/Icon";
import {addDetailWindow} from "../../actions/details";

class IndicatorObjectList extends React.Component {
    static propTypes = {
        addDetailWindow: PropTypes.func,
        panTo: PropTypes.func,
        removeForIndicators: PropTypes.func,
        selectedObjects: PropTypes.array,
        zoomToExtent: PropTypes.func
    }
    static defaultProps = {}

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            isLoading: true,
            url: null,
        };
    }

    async zoomTo(feature) {
        if (this.hasGeometry(feature)) {
            const extend = geojsonBbox(feature);
            await this.props.zoomToExtent(extend, 'EPSG:4326', -2);
        }
    }

    panTo(feature) {
        if (this.hasGeometry(feature)) {
            const bounds = geojsonBbox(feature);
            const center = [0.5 * (bounds[0] + bounds[2]), 0.5 * (bounds[1] + bounds[3])];
            this.props.panTo(center, 'EPSG:4326');
        }
    }

    hasGeometry(feature) {
        return (feature && feature.geometry);
    }

    render() {
        if (this.props.selectedObjects.length == 0) {
            return null;
        }
        return (
            <div className="indicators-objectlist">
                <strong>{LocaleUtils.tr('indicators.selectedobjects')}</strong>
                {this.props.selectedObjects.map(object => {
                    return (
                        <div key={'indojb' + object.properties.id}>
                            <span>
                                {TypeUtils.getObjectLabel(object.properties.linkedObjectType, object.linkedObject)}
                            </span>
                            <div>
                                <Icon icon="info-sign" onClick={() => this.props.addDetailWindow(object.linkedObject)}/>
                                <Icon icon="zoom" onClick={() => this.zoomTo(object.linkedObject)}/>
                                <Icon icon="arrows" onClick={() => this.panTo(object.linkedObject)}/>
                                <span className="icon icon-trash" onClick={() => this.props.removeForIndicators(object)}></span>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

const selector = (state) => ({
    selectedObjects: state.indicators.selectedObjects,
});

export default connect(selector, {
    addDetailWindow: addDetailWindow,
    removeForIndicators: removeForIndicators,
    zoomToExtent: zoomToExtent,
    panTo: panTo
})(IndicatorObjectList);
